import React from 'react'
import Layout from '../components/Layout/Layout'
import Courses from '../components/Courses/Courses'

const courses = () => (
  <Layout>
    <Courses type="course-timer" />
  </Layout>
)

export default courses
